import React, { PureComponent } from 'react';
import { number, func } from 'prop-types';
import compose from 'lodash/flowRight';
import { Pagination } from 'components';
import { paginationOffsetShape, locationShape } from 'shapes';
import {
    withPagination,
    withPaginationOffset,
    withFeatureFlags,
    withLocation,
} from 'connectors';

import './PaginationWrapper.scss';

class PaginationWrapper extends PureComponent {
    static propTypes = {
        nbHits: number, // eslint-disable-line react/no-unused-prop-types
        page: number, // eslint-disable-line react/no-unused-prop-types
        onPageChange: func,
        nbHitsPerPage: number.isRequired, // eslint-disable-line react/no-unused-prop-types
        paginationOffset: paginationOffsetShape.isRequired, // eslint-disable-line react/no-unused-prop-types
        location: locationShape.isRequired,
        maxProducts: number.isRequired, // eslint-disable-line react/no-unused-prop-types
    };

    static defaultProps = {
        onPageChange: () => {},
        nbHits: 0,
        page: 1,
    };

    static getDerivedStateFromProps(props, state) {
        let newState = {};
        const nbHits =
            props.nbHits > props.maxProducts ? props.maxProducts : props.nbHits;

        if (nbHits !== state.nbHits) {
            let nbPages = Math.ceil(
                (nbHits + props.paginationOffset.listingOffset) /
                    props.nbHitsPerPage,
            );
            if (props.nbHits > props.maxProducts) {
                nbPages -= 1; // because algolia wont return hits when offset is around the limit (20000)
            }
            newState = {
                ...newState,
                nbPages,
                nbHits,
            };
        }

        if (Object.keys(newState).length === 0) {
            newState = null;
        }

        return newState;
    }

    state = {
        nbPages: 1,
        nbHits: null,
    };

    render() {
        const { onPageChange, page, location } = this.props;
        const { nbPages } = this.state;

        return (
            <div className="pagination__wrapper">
                <Pagination
                    onPageChange={onPageChange}
                    nbPages={nbPages}
                    currentPage={page}
                    location={location}
                />
            </div>
        );
    }
}

export default compose(
    withFeatureFlags({
        nbHitsPerPage: 'instantSearch.resultsPerPage',
        maxProducts: 'browsing.products.max',
    }),
    withPagination,
    withPaginationOffset,
    withLocation,
)(PaginationWrapper);
